/* eslint-disable jsx-a11y/anchor-is-valid */
import type { FC } from "react";

import "svgmap/dist/svgMap.min.css";
import NavbarSidebarLayout from "../layouts/navbar-sidebar";
import { Breadcrumb } from "flowbite-react";
import { HiHome } from "react-icons/hi";
import UserProfilePage from "./profile";

const HomePage: FC = function () {
  return (
    <NavbarSidebarLayout>
     <div className=" h-screen pb-20 overflow-y-auto mb-6 grid grid-cols-1 gap-y-6 px-4 pt-6 dark:border-gray-700 dark:bg-gray-900 xl:grid-cols-2 xl:gap-4">
             <div className="col-span-full">
               <Breadcrumb className="mb-4">
                 <Breadcrumb.Item href="/">
                   <div className="flex items-center gap-x-3">
                     <HiHome className="text-xl" />
                     <span className="dark:text-white">Home</span>
                   </div>
                 </Breadcrumb.Item>
               </Breadcrumb>
               <h1 className="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl">
                 Home
               </h1>
               <UserProfilePage/>
             </div>
            
           </div>
    </NavbarSidebarLayout>
  );
};


export default HomePage;
